import { Select } from "antd/es";


export const ImageSelector = (props) => {
    const { bind: [value, setValue], imageNames } = props;

    return (
        <Select
            value={value}
            placeholder={`Analyze specific dataset image... (${imageNames.length})`}
            options={imageNames}
            onChange={v => setValue(v)}
            virtual={true}
            allowClear
            style={{ width: '100%' }}
            showSearch />
    );
};
